export const getNormalizedUrl = (): string =>
  window.location.hostname.indexOf("www.") >= 0
    ? window.location.hostname
    : `www.${window.location.hostname}`;

export const getToolUrl = (tool: string): string =>
  `${window.location.protocol}//${window.location.hostname.replace(
    "floorplanning-rent",
    tool,
  )}/?hostname=${localStorage.getItem("floorplanning_rent_hostname")}&&`;

export const getMyHomeUrl = (): string =>
  `${getToolUrl("myhome-rent")}returnUrl=${window.location.hostname}`;

export const getBackUrl = (): string => {
  const backToURL = new URL(window.location.href);
  const params = new URLSearchParams(backToURL.search);
  const backTo = `${window.location.origin}/?${params}`;
  return backTo.endsWith("?") ? backTo.replace("?", "") : backTo;
};

export const detectUrl = (baseHost: string, host?: string): string => {
  let hostname = getNormalizedUrl();

  const urlParams = new URLSearchParams(window.location.search);
  const hostnameParam = urlParams.get("hostname");

  if (
    hostname.indexOf("localhost") >= 0 ||
    hostname.indexOf(".ddns.net") >= 0 ||
    hostname.indexOf("biz-tecma") >= 0 ||
    hostname.indexOf("-demo.tecmasolutions.com") >= 0
  ) {
    if (hostnameParam && hostnameParam.length > 0 && hostnameParam !== "") {
      localStorage.removeItem("coliving_hostname");
      delete localStorage.coliving_hostname;
      localStorage.setItem("coliving_hostname", hostnameParam);
    }

    const storageHostName = localStorage.getItem("coliving_hostname");

    if (
      storageHostName &&
      storageHostName.length > 0 &&
      storageHostName !== ""
    ) {
      return storageHostName;
    }

    hostname = host || baseHost;
  }

  return hostname;
};
